export default __webpack_public_path__ + "static/november-pro-bold-b6dd1e4b7a47473eed3a699053840071.woff2";